export default [
  {
    description: 'Página Global HTML',
    path: '/global/pagina/viewer/:id',
    name: 'page_viewer',
    component: () => import('@/views/global/pagina/PageViewer.vue'),
    meta: {
      isLegacy: true
    },
    goesToMenu: true,
  },
]

